import React, { useEffect } from 'react';
import { Jumbotron } from '../../../../infrastructure/components/Layout/Jumbotron';
import UserManager from '../../../../application/common/usermanagement';

import './Logout.css';

export const Logout: React.FC = () => {

  useEffect(() => {
    UserManager.logoutUser(true);
  })

  return (
    <>
      <Jumbotron title="Redirecting..."/>
    </>
  );
};
